<h1>{{ 'MAIN_DASHBOARD.WS_DIRECTORY' | translate }}</h1>

<div class="content-container admin m-t-20">
  <div class="ui-g">
    <h3>{{ 'DATA_PORTAL.ADMINISTRATION.TITLE' | translate }}</h3>
    <div class="ui-g-12">
      <p-tabView>
        <p-tabPanel
          [header]="'DATA_PORTAL.ADMINISTRATION.CENSUS.LINK_NAME' | translate"
          [selected]="selectedTab === tabTypes.CENSUS">
          <ng-template pTemplate="content">
            <div *gsShowIfHasPermission="['NDP_ORGANIZATION_CENSUS_PERIOD_READ']">
              <wsd-census-future></wsd-census-future>
            </div>
          </ng-template>
        </p-tabPanel>
        <p-tabPanel
          [header]="'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.LINK_NAME' | translate"
          [selected]="selectedTab === tabTypes.AGE_GROUPS">
          <ng-template pTemplate="content">
            <div *gsShowIfHasPermission="['NDP_ORGANIZATION_AGE_GROUP_READ']">
              <wsd-age-group></wsd-age-group>
            </div>
          </ng-template>
        </p-tabPanel>
        <p-tabPanel
          [header]="'DATA_PORTAL.ADMINISTRATION.BENEFICIARIES.LINK_NAME' | translate"
          [selected]="selectedTab === tabTypes.BENEFICIARIES">
          <ng-template pTemplate="content">
            <div *gsShowIfHasPermission="['NDP_ORGANIZATION_BENEFICIARY_CATEGORY_READ']">
              <wsd-beneficiaries></wsd-beneficiaries>
            </div>
          </ng-template>
        </p-tabPanel>
        <p-tabPanel
          [header]="'WS_DIRECTORY.POLICY_DOCUMENTS.LINK_NAME' | translate"
          [selected]="selectedTab === tabTypes.POLICY_DOCUMENTS">
          <ng-template pTemplate="content">
            <div *gsShowIfHasPermission="['WSD_POLICY_DOCUMENTS_READ']">
              <wsd-policy-documents-organization></wsd-policy-documents-organization>
            </div>
          </ng-template>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>
